import { render, staticRenderFns } from "./AuthorizationDetailLayout.vue?vue&type=template&id=19f45d6a"
import script from "./AuthorizationDetailLayout.vue?vue&type=script&lang=js"
export * from "./AuthorizationDetailLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports